// Romanian
export const ro = {
    weeklyRewards: 'Recompense săptămânale în',
    days: 'zile',
    hours: 'ore',
    minutes: 'min',
    seconds: 'sec',
    authenticating: 'Autentificare',
    verifyWallet: 'Vă rugăm așteptați în timp ce vă verificăm portofelul',
    authRequired: 'Autentificare necesară',
    authFailed: 'Autentificare eșuată. Vă rugăm încercați din nou.',
    points: 'Puncte',
    rank: 'Rang',
    of: 'din',
    players: 'jucători',
    weeklyTopPlayers: 'Cei mai buni jucători ai săptămânii',
    thisWeekLeaderboard: 'Clasamentul acestei săptămâni',
    rankingsReset: 'Clasamentul se resetează în fiecare duminică la miezul nopții UTC',
    yourPoints: 'Punctele tale',
    dailyRewardAvailable: 'Recompensă zilnică disponibilă!',
    nextClaimAvailable: 'Următoarea revendicare disponibilă în:',
    claimDailyReward: 'Revendică recompensa zilnică',
    claiming: 'Se revendică...',
    multiplier: 'Multiplicator',
    bonusPointsMultiplier: 'Multiplicator puncte bonus',
    outOf: 'din',
    loading: 'Se încarcă...',
    errorLoading: 'Eroare la încărcare',
    noEntries: 'Nicio intrare',
    leaderboard: 'Clasament',
    tasks: 'Sarcini',
    rules: 'Reguli',
    profile: 'Profil',
    comingSoon: 'În curând...',
    completedTasks: 'Sarcini completate',
    dailyRewardsClaimed: 'Recompense zilnice revendicate',
    times: 'ori',
    recentActivity: 'Activitate recentă',
    noRewardsClaimed: 'Nicio recompensă revendicată încă',
    dailyReward: 'Recompensă zilnică',
    howItWorks: 'Cum funcționează',
    welcomeMessage:
        'Bine ați venit la Coinomi Rewards! Câștigați puncte completând diverse sarcini și urcați în clasament.',
    dailyRewardsTitle: 'Recompense zilnice',
    dailyRewardsRules: [
        'Revendicați recompensa zilnică la fiecare 24 de ore',
        'Fiecare revendicare valorează 100 de puncte',
        'Punctele sunt înmulțite cu multiplicatorul dvs.',
    ],
    multiplierBonusesTitle: 'Bonusuri multiplicator',
    multiplierBonusesRules: [
        'Începeți cu multiplicator 1x',
        'Conectați Telegram pentru bonus +10%',
        'Verificați emailul pentru bonus +10%',
        'Bonusurile se cumulează pentru recompense maxime',
    ],
    leaderboardTitle: 'Clasament',
    leaderboardRules: [
        'Concurați cu alți jucători',
        'Clasamentul se actualizează în timp real',
        'Cei mai buni jucători primesc recompense speciale',
    ],
    boostEarningsTitle: 'Creșteți câștigurile',
    boostEarningsRules: [
        'Completați provocări pentru bonusuri',
        'Alăturați-vă comunității noastre Telegram',
        'Rămâneți activ pentru recompense maxime',
    ],
    challenges: 'Provocări',
    telegramChallenge: 'Provocare Telegram',
    emailChallenge: 'Provocare Email',
    connectTelegram: 'Conectare Telegram',
    shareEmail: 'Partajare email',
    telegramSuccess: '🎉 Felicitări! Acum primiți un bonus permanent de 10% la toate recompensele!',
    telegramPrompt:
        'Conectați-vă contul Telegram pentru a primi un bonus permanent de 10% la toate recompensele!',
    emailSuccess: '🎉 Felicitări! Acum primiți un bonus permanent de 10% la toate recompensele!',
    emailPrompt:
        'Partajați emailul pentru a primi un bonus permanent de 10% la toate recompensele!',
    connectEmail: 'Conectare email',
    cancel: 'Anulare',
    emailPrivacy:
        'Folosim emailul dvs. doar pentru actualizări importante și notificări despre recompense.',
    connectYourEmail: 'Conectați-vă emailul',
    emailBonus: '🎉 Primiți un bonus permanent de 10% la toate recompensele conectându-vă emailul!',
    enterValidEmail: 'Vă rugăm introduceți o adresă de email validă',
    emailAddress: 'Adresă email',
    errorSavingEmail: 'Eroare la salvarea emailului. Vă rugăm încercați din nou.',
    claimButton: 'Revendică',
    earnedReward: 'Recompensă câștigată',
    rewardValue: '{{amount}} Puncte',
    claimingReward: 'Se revendică...',
    claimSuccess: 'Revendicat cu succes {{amount}} puncte!',
    claimError: 'Revendicare eșuată. Vă rugăm încercați din nou.',
    privacyDisclaimer:
        'Coinomi nu colectează date personale; un sistem terț gestionează în siguranță punctele și conexiunile sociale.',
    streakBonus: 'Bonus serie',
    streakDays: '{{days}}/5 Zile',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Extra',
    streakDescription: 'Revendicați 5 zile consecutive pentru bonus maxim',
    streakToday: 'Astăzi',
    streakMissed: 'Ratat',
    streakComplete: 'Complet',
    streakActive: 'Serie activă',
    streakLost: 'Serie pierdută',
    streakNext: 'Următorul',
    home: 'Acasă',
    currentStreak: 'Serie curentă',
    totalClaims: 'Total revendicări',
    userStats: 'Statisticile tale',
    referrals: 'Recomandări',
    referralProgram: 'Program de recomandare',
    howReferralWorks: 'Cum funcționează recomandările:',
    referralSteps: [
        'Partajați linkul de recomandare cu prietenii',
        'Când se alătură prin linkul dvs., devin recomandații dvs.',
        'Câștigați puncte bonus pentru fiecare recomandare activă',
        'Urmăriți recomandările și câștigurile dvs. aici',
    ],
    referralRewards: 'Puncte de recomandare acordate:',
    referralBonuses: [
        '100 puncte per recomandare',
        '10% din toate punctele câștigate de recomandații dvs.',
    ],
    yourReferralLink: 'Linkul dvs. de recomandare',
    copyToClipboard: 'Copiază în clipboard',
    linkCopied: 'Link copiat în clipboard!',
    totalReferrals: 'Total recomandări',
    yourReferralCode: 'Codul dvs. de recomandare',
    referralCodeCopied: 'Cod de recomandare copiat!',
    editReferralCode: 'Editare cod de recomandare',
    editReferralCodeInstructions:
        'Alegeți un nou cod de recomandare. Trebuie să aibă minim 5 caractere și poate include litere și cifre.',
    newReferralCode: 'Cod nou de recomandare',
    referralCodeRequirements: 'Minim 5 caractere, doar litere și cifre',
    updating: 'Se actualizează...',
    update: 'Actualizare',
    referralCodeTaken: 'Acest cod de recomandare este deja folosit',
    haveReferralCode: 'Aveți un cod de recomandare?',
    enterReferralCodePrompt:
        'Dacă cineva v-a recomandat, introduceți codul lor aici pentru a conecta conturile.',
    enterReferralCode: 'Introduceți cod de recomandare',
    enterReferralCodeInstructions: 'Introduceți codul de recomandare care a fost partajat cu dvs.',
    referralCode: 'Cod de recomandare',
    referralCodeFormat: 'Doar litere și cifre',
    submitting: 'Se trimite...',
    submit: 'Trimite',
    enterCode: 'Introduceți cod',
    pleaseAddtoken: 'Vă rugăm adăugați parametrul token la URL',
    authenticationError: 'A apărut o eroare în timpul autentificării',
    noUserFound: 'Niciun utilizator găsit',
    userNotFoundMessage: 'Nu s-au putut găsi datele utilizatorului',
    backToHome: 'Înapoi acasă',
    retry: 'Încearcă din nou',
    baseMultiplier: 'Multiplicator de bază',
    telegramBonus: 'Bonus Telegram',
    referralChallenge: 'Provocare recomandări',
    referralChallengePrompt:
        'Invitați prieteni și câștigați puncte bonus! Primiți 100 puncte pentru fiecare recomandare plus 10% din câștigurile lor.',
    startReferring: 'Începeți să recomandați',
    referralSuccess:
        '🎉 Felicitări! Ați recomandat cu succes utilizatori și câștigați puncte bonus!',
    unranked: 'Neclasificat',
    noPlayersYet: 'Fiți primul care se alătură!',
    shareVia: 'Partajează prin',
    shareOn: 'Partajează pe {{network}}',
    shareInviteText:
        '🚀 Câștig crypto gratuit cu @CoinomiWallet!\n\nDescarcă Coinomi de la coinomi.com/downloads și introdu codul meu de recomandare {{referralCode}} pentru a primi un bonus când te alături #Coinomi Rewards în aplicație.',
    // Twitter Challenge
    twitterChallenge: 'Provocarea Twitter',
    connectTwitter: 'Conectează Twitter',
    twitterSuccess: '🎉 Felicitări! Acum primești un bonus permanent de 10% la toate recompensele!',
    twitterPrompt:
        'Conectează-ți contul de Twitter pentru a primi un bonus permanent de 10% la toate recompensele!',
    pleaseAddUserId: 'Vă rugăm adăugați parametrul userId la URL',
    emailChallengePrompt:
        'Partajați emailul pentru a primi un bonus permanent de 10% la toate recompensele!',
    emailChallengeSuccess:
        '🎉 Conectat! Acum primiți un bonus permanent de 10% la toate recompensele!',
    followKoalaWalletChallenge: 'Urmăriți @coinomiWallet pe Twitter pentru a ne susține!',
    twitterAuthSuccessTitle: 'Twitter conectat cu succes!',
    twitterAuthSuccessMessage:
        'Contul dvs. de Twitter a fost conectat cu succes. Acum puteți continua să utilizați aplicația.',
    continueToApp: 'Continuați către aplicație',
    twitter_like: 'A apreciat un tweet',
    twitter_retweet: 'A retweetat un tweet',
    disconnect: 'Deconectează',
    followCoinomiWallet: 'Urmărește @coinomiWallet pe Twitter pentru a ne susține!',
    connectedBonus: '🎉 Conectat! Acum primiți un bonus permanent de 10% la toate recompensele!',
};
